import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import monopolylogo from '../Header/assets/ga-monopoly-logo.png';
import styles from './mainmenu.module.scss';

const MainMenu = ({ menuLinks }) => (
    <nav className={styles.mainMenu} aria-label="Main Menu">
        <ul className={styles.navList}>
            {menuLinks.slice(0, 4).map((link, key) => (
                <li className={styles.navItem} key={`main-menu-left--${key}`}>
                    <Link
                        to={link.uri}
                        className={styles.navLink}
                        activeClassName={styles.active}
                    >
                        {link.title}
                    </Link>
                </li>
            ))}

            <li>
                <a href="/monopoly" className={styles.promoLogo}>
                    <img src={monopolylogo} alt="MONOPOLY For Life" />
                </a>
            </li>

            {menuLinks.slice(-3).map((link, key) => (
                <li className={styles.navItem} key={`main-menu-right--${key}`}>
                    <Link
                        to={link.uri}
                        className={styles.navLink}
                        activeClassName={styles.active}
                    >
                        {link.title}
                    </Link>
                </li>
            ))}



        </ul>
    </nav>
);

MainMenu.propTypes = {
    menuLinks: PropTypes.arrayOf(
        PropTypes.shape({
            uri: PropTypes.string,
            title: PropTypes.string,
        })
    ),
};

export default MainMenu;
